'use client';
import createIconSet from './createIconSet';
import font from './vendor/react-native-vector-icons/Fonts/Feather.ttf';
import glyphMap from './vendor/react-native-vector-icons/glyphmaps/Feather.json';
export default createIconSet(glyphMap, 'feather', font);
//# sourceMappingURL=Feather.js.map